<div class="mob-legal">
    <div class="container">
        <div class="row">
            <div class="col-12">
                 <div [innerHTML]="VO?.legal" class="mob-text-2 mb-64 mb-lg-80">                    
                 </div>
                <div class="mob-hr mb-40 mb-lg-48"></div>
                <div [innerHTML]="VO?.footer" class="mob-text-2"></div>
            </div>
        </div>
    </div>
</div>